<template>
  <div class="dropDown">
    <el-select v-model="value" placeholder="请选择">
      <el-option
        v-for="item in list"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      >
      </el-option>
    </el-select>
  </div>
</template>
<script>
export default {
     props: ["list",],
    data(){
        return{
            value:''
        }
    },


    watch:{
        value(){
            this.$emit('dropChange',this.value)
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Denominated/dropDown.vue